import React from "react";
import { useTranslation } from "react-i18next";

//Materual-UI Icons
import AddIcon from "@material-ui/icons/Add";

//Custom Components
import CardActionButton from "UI/Card/CardActionButton";

function CardActionButtonAdd(props) {
  const { t } = useTranslation();

  return (
    <CardActionButton startIcon={<AddIcon />} {...props} aria-label="add" aria-controls="add">
      {t("buttons.add")}
    </CardActionButton>
  );
}

export default CardActionButtonAdd;
